import React from "react";
import { string, objectOf, object } from "prop-types";

const CommentIcon = ({ style, className }) => (
	<i style={{ ...style, fill: "currentColor" }} className={className}>
		<svg
			viewBox="0 0 1004.15 690"
			style={{
				width: "100%",
				height: "100%",
			}}>
			<use xlinkHref="#sw-quick-lins-support-comment-icon" />
		</svg>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid"
			style={{ display: "none" }}>
			<defs>
				<path
					id="sw-quick-lins-support-comment-icon"
					d="M1004.15 482l-60.5-65.23A254.61 254.61 0 0 0 954 345C954 154.46 740.44 0 477 0S0 154.46 0 345s213.56 345 477 345c195.86 0 364.14-85.38 437.6-207.48z"
				/>
			</defs>
		</svg>
	</i>
);

CommentIcon.propTypes = {
	className: string,
	style: objectOf(object),
};
CommentIcon.defaultProps = {
	className: "",
	style: {},
};
export default CommentIcon;
export { CommentIcon };
